import React, { ReactNode } from 'react';
import { useFormik } from 'formik';
import _, { set } from 'lodash';

import {
  Row,
  Col,
  Form,
  Button,
  InputGroup,
  Modal,
  Offcanvas,
  Badge,
} from 'react-bootstrap';
import styled from 'styled-components';

import { Spin, Tooltip, Divider, Checkbox, Radio } from 'antd';
import CurrencyInput from 'react-currency-input-field';

import SmartSelect from '../../components/select/SmartSelect.tsx';
import SmartAutocomplete from '../../components/autocomplete/SmartAutocomplete.tsx';

// Redux
import { useDispatch, useSelector } from "react-redux";
import { RootState } from '../../../../setup'
import slice, { FormikContext, fields, initialValues, formSchema, prepareForm, prepareData, initBundleItem, addBillingCategory, getSelectedTaxRate, getBillingPerKgTons, getBillingKgTons, getMaxLength, LocalGlobal, BinWaste } from './slice.tsx';
import taxRate from "../../utils/slices/taxRate.tsx";
import billingCategorySlice from "./billingCategory/slice.tsx";
import { BillingTypes } from '../jobs/slice';

// enums
import { danger, warning, dateFormat, getMaxPageSize, scrollTo, limitRows, getCurrency, isNumberAvoidZero, isNumeric, hasEmptyRows, isEmptyRow } from '../../../v5/utils/utils.tsx';
import { ServiceType } from '../../../v5/utils/enums.tsx';

import DefaultTaxRatePopup from './defaultTaxRate/Form.tsx';
import BillingCategoryForm from './billingCategory/Form.tsx';

import ModalCreateItemForm from '../../components/modal/createItem/Form.tsx';
import modalCreateItemSlice from '../../components/modal/createItem/slice.tsx';

import { ReactComponent as PlusIcon } from "../../../v5/assets/icons/plus.svg";
import { ReactComponent as TrashIcon } from "../../../v5/assets/icons/trash.svg";
import { ReactComponent as ArrowDownIcon } from "../../../v5/assets/icons/arrow-down.svg";
import { ReactComponent as ArrowUpIcon } from "../../../v5/assets/icons/arrow-up.svg";
import { ReactComponent as InfoIcon } from "../../../v5/assets/icons/alert-info.svg";
import { ReactComponent as SettingsIcon } from "../../../v5/assets/icons/settings.svg";
import { ReactComponent as CheckboxUncheckedIcon } from "../../../v5/assets/icons/checkbox-unchecked.svg";
import { ReactComponent as CheckboxCheckedIcon } from "../../../v5/assets/icons/checkbox-checked.svg";

// ----------------------------------------------------------------------

const StyledRowForm = styled(Row)`
    .form-label {
        line-height: 20px !important;
        color: $gray-900 !important;
        font-weight: $font-weight-semibold !important;
    }

    input, textarea, .ant-select-selection-item {
        font-family: 'Inter', sans-serif !important;
        font-size: 14px !important;
    }
    .input-group-text {
        font-family: 'Inter', sans-serif !important;
        font-size: 13.5px !important;
    }

    .form-text {
        line-height: 18px !important;
        color: $gray-800 !important;
        font-weight: $font-weight-normal !important;
    }

    &::placeholder, .ant-select-selection-placeholder {
        color: $gray-500 !important;
        font-family: 'Inter', sans-serif !important;
        font-size: 14px !important;
    }

    .ant-select-dropdown {
        .custom-select-footer {
            padding: 0px;

            button {
                padding-top: 5px;
                padding-bottom: 5px;
            }
        }
    }
`;

const StyledInfoIcon = styled(InfoIcon)`
  position: relative;
  top: 0px;
  width: 18px;
  height: 19px;
  margin-left: 6px;
  cursor: pointer;

  path {
    stroke: var(--bs-gray-600);
  }
`;

const StyledButton = styled(Button)`
   &.btn-sm {
    padding: 4px 10px !important;
    font-size: 12px !important;
    font-weight: 500 !important;
    line-height: 20px !important;
  }

  
  svg {
    position: relative !important;
    top: -1px !important;
    width: 16px;
    height: 16px;
  }
`;

const StyledCol = styled(Col)`
    border: 1px solid var(--bs-gray-300);
    border-radius: 8px;
    padding: 16px;
`;

const StyledDivider = styled(Divider)`
    margin-top: 0px;
    margin-bottom: 8px;
    border-color: var(--bs-gray-100);
`;

const StyledA = styled.a`
    svg {
        path {
            stroke: var(--bs-blue-500);
        }
    }

    &:hover {
        svg {
            path {
                stroke: var(--bs-gray-700);
            }
        }
    }
`;

const StyledSmartSelect = styled(SmartSelect)`
    &.is-invalid {
        padding-right: 0px !important;s
    }
`;

const StyledSmartAutocomplete = styled(SmartAutocomplete)`
    &.is-invalid {
        padding-right: 0px !important;s
    }
`;


const FormComponent = (props: any) => {
    const dispatch = useDispatch();
    const { isLoading, show, customerId, id, isCopy, details, isLoadingCheckName, isLocalGlobal } = useSelector((state: RootState) => state.servicesSlice);
    const taxRateSlice = useSelector((state: RootState) => state.taxRateSlice);


    React.useEffect(() => {
        if(show){
            if(customerId){
                dispatch(taxRate.getCustomerProfileApi(customerId, (state: boolean, data: any) => {}));
            } else {
                dispatch(taxRate.getDefaultProfileApi((state: boolean, data: any) => {}));
            }
            dispatch(taxRate.getDefaultTaxRateApi((state: boolean, data: any) => {}));

            if(id && id > 0){
                dispatch(slice.callDetailsApi(id, (state: boolean, data: any) => {}));
            } else {
                setTimeout(() => {
                    setErrors({});
                }, 0);
            }
        }
    }, [show, id]);
        
    React.useEffect(() => {
        dispatch(slice.setLoading(true));
        let form = prepareForm(details, initialValues, id, isCopy, isLocalGlobal);
        setValues(form);
        setTimeout(() => {
            setErrors({});
        }, 0);
        dispatch(slice.setLoading(false));
    }, [details]);


    const formik = useFormik({
        initialValues: initialValues,
        validateOnMount: false,
        validateOnChange: true,
        validationSchema: formSchema(null, isLocalGlobal),
        onSubmit: values => {
            onSubmit(values, (data: any) => {
                if(props && props.onSave){
                    props.onSave(data);
                }
                
                onCancel();
            });
        },
    });
    const { values, errors, setValues, setErrors, setFieldValue, validateForm, handleSubmit }: any = formik;


    const onSubmit = (values: any, callback: (data: any) => void) => {
        if(id > 0){
            if(isCopy){
                let data = prepareData(values, customerId, null, true, isLocalGlobal);
                dispatch(slice.callCreateApi(data, (state: boolean, data: any) => {
                    if(state){
                        callback(data);
                    }
                }));

            } else {
                let data = prepareData(values, customerId, id, false, isLocalGlobal);
                dispatch(slice.callUpdateApi(data, (state: boolean, data: any) => {
                    if(state){
                        callback(data);
                    }
                }));
            }

        } else {
            let data = prepareData(values, customerId, null, false, isLocalGlobal);
            dispatch(slice.callCreateApi(data, (state: boolean, data: any) => {
                if(state){
                    callback(data);
                }
            }));
        }
    }
    const onCancel = () => {
        let form = prepareForm(null, initialValues, null, false, isLocalGlobal);
        setValues(form);
        dispatch(slice.setValues(form));
        setTimeout(() => {
            setErrors({});
        }, 0);
        dispatch(slice.setShow({ show: false, customerId: null, id: null, isCopy: false, isLocalGlobal: null }));
        dispatch(slice.resetSlice());
    }

    
    const setFooter = () => {
        return <Row className='w-100 gx-12'>
            <Col xs={true} className='text-end'>
                <Button
                    className='me-5'
                    variant={'custom-text'}
                    size={'sm'}
                    disabled={isLoading}
                    onClick={(e) => {
                        onCancel();
                    }}
                >Cancel</Button>
                <Button
                    variant={'custom-primary'}
                    size={'sm'}
                    disabled={isLoading}
                    onClick={() => {
                        handleSubmit()
                    }}
                >Save</Button>
            </Col>
        </Row>
    }
    
    const setForm = () => {
        return <StyledRowForm className={'gx-0 gy-16'}>
            <>{setMainServiceElements()}</>
            
            {values.hasBinWaste && <StyledCol xs={12}>{setWasteBinElement()}</StyledCol>}

            {values.hasBillingPermission && <>{setMainRateElements()}</>}
            
            <Col xs={12}>
                <Row className='gx-0 gy-16'>

                    {/* TOP ADD BIN&WASTE BTN */}
                    {(values.bundleServices && values.bundleServices.length > 0) && <Col xs={12}>
                        <Row className={'g-8'}>
                            {!values.hasBinWaste && <Col xs={'auto'}>
                                <StyledButton
                                    variant={'custom-secondary'}
                                    size={'sm'}
                                    onClick={(e: any) => {
                                        e.preventDefault();
                                        e.stopPropagation();

                                        setFieldValue('hasBinWaste', true);
                                    }}
                                ><PlusIcon /> Add Waste & Bin</StyledButton>
                            </Col>}

                            <Col xs={12}><StyledDivider className='mt-8' /></Col>
                        </Row>
                    </Col>}
                    {/* END TOP ADD BIN&WASTE BTN */}

                    {/* TOP BUNDLE ITEMS */}
                    <>{(values.bundleServices && values.bundleServices.length > 0) && values.bundleServices.sort((a: any, b: any) => a.order - b.order).map((item: any, i: number) => {
                        return <StyledCol xs={12} key={'service_bundle_item_' + i} className={'service-bundle-item-' + i}>{setBundleForm(item, i)}</StyledCol>
                    })}</>
                    {/* END BUNDLE ITEMS */}

                    {/* BOTTOM ADD BIN&WASTE AND SERVICE BTN */}
                    <Col xs={12}>
                        <Row className={'g-8'}>
                            {!(values.bundleServices && values.bundleServices.length > 0) && <Col xs={12}><StyledDivider /></Col>}

                            {(!values.hasBinWaste && !(values.bundleServices && values.bundleServices.length > 0)) && <Col xs={'auto'}>
                                <StyledButton
                                    variant={'custom-secondary'}
                                    size={'sm'}
                                    onClick={(e: any) => {
                                        e.preventDefault();
                                        e.stopPropagation();

                                        setFieldValue('hasBinWaste', true);
                                    }}
                                ><PlusIcon /> Add Waste & Bin</StyledButton>
                            </Col>}

                            <Col xs={'auto'}>
                                <StyledButton
                                    variant={'custom-secondary'}
                                    size={'sm'}
                                    onClick={(e: any) => {
                                        e.preventDefault();
                                        e.stopPropagation();

                                        validateForm().then((err: any) => {
                                            if (err && Object.entries(err).length > 0) {
                                                warning('Warning', 'You must fill in the required fields');
                                            } else {
                                                let items = (values.bundleServices && values.bundleServices.length > 0) ? _.cloneDeep(values.bundleServices) : [];
                                                let newItem = _.cloneDeep(initBundleItem);
                                                newItem.order = items.length + 1;
                                                items.push(newItem);
                                                
                                                setFieldValue('bundleServices', items);
                                                scrollTo('.service-bundle-item-' + (items.length-1));
                                            }
                                        })
                                    }}
                                ><PlusIcon /> Add Service</StyledButton>
                            </Col>
                        </Row>
                    </Col>
                    {/* END BOTTOM ADD BIN&WASTE AND SERVICE BTN */}

                </Row>
            </Col>
        </StyledRowForm>
    }
    const setBundleForm = (item: any, i: number) => {
        return <Row className='g-16'>
            <Col xs={true} className='fs-16 semibold gray-600'>Service</Col>
            <Col xs={'auto'}>
                <Row className='g-8'>
                    {(i > 0) && <Col xs={'auto'}>
                        <StyledButton
                            variant={'custom-outlined'}
                            style={{ border: '1px solid var(--bs-gray-300)' }}
                            size={'sm'}
                            onClick={(e: any) => {
                                e.preventDefault();
                                e.stopPropagation();

                                let items = _.cloneDeep(values.bundleServices);

                                if (i > 0) {
                                    [items[i - 1], items[i]] = [items[i], items[i - 1]];
                                }
                            
                                items = items.map((item: any, index: number) => ({
                                    ...item,
                                    order: index + 1,
                                }));
  
                                setFieldValue('bundleServices', items);
                            }}
                        ><ArrowUpIcon /> Move Up</StyledButton>
                    </Col>}

                    {(i < (values.bundleServices.length-1)) && <Col xs={'auto'}>
                        <StyledButton
                            variant={'custom-outlined'}
                            style={{ border: '1px solid var(--bs-gray-300)' }}
                            size={'sm'}
                            onClick={(e: any) => {
                                e.preventDefault();
                                e.stopPropagation();

                                let items = _.cloneDeep(values.bundleServices);

                                if (i < items.length - 1) {
                                [items[i], items[i + 1]] = [items[i + 1], items[i]];
                                }

                                items = items.map((item: any, index: number) => ({
                                ...item,
                                order: index + 1,
                                }));

                                setFieldValue('bundleServices', items);
                            }}
                        ><ArrowDownIcon /> Move Down</StyledButton>
                    </Col>}

                    <Col xs={'auto'}>
                        <StyledButton
                            variant={'custom-secondary-danger'}
                            style={{ border: '1px solid transparent' }}
                            size={'sm'}
                            onClick={(e: any) => {
                                e.preventDefault();
                                e.stopPropagation();

                                let items = _.cloneDeep(values.bundleServices);
                                items.splice(i, 1);
                                setFieldValue('bundleServices', items);
                            }}
                        ><TrashIcon /> Remove</StyledButton>
                    </Col>
                </Row>
            </Col>
            
            <>{setBundleServiceElements(item, i)}</>
            <>{setBundleRateElements(item, i)}</>
        </Row>
    }

    const setWasteBinElement = () => {
        return <Row className='g-16'>
            <Col xs={true} className='fs-16 semibold gray-600'>Waste & Bin Type</Col>
            <Col xs={'auto'}>
                <StyledButton
                    variant={'custom-secondary-danger'}
                    size={'sm'}
                    onClick={async (e: any) => {
                        e.preventDefault();
                        e.stopPropagation();

                        await setFieldValue('hasBinWaste', false);
                        
                        await setFieldValue('wasteTypeId', null);
                        await setFieldValue('wasteTypeName', '');
                        await setFieldValue('wasteType', null);
                        
                        await setFieldValue('binTypeId', null);
                        await setFieldValue('binTypeName', '');
                        await setFieldValue('binType', null);
                    }}
                ><TrashIcon /> Remove</StyledButton>
            </Col>
            <Col xs={12}>
                <Form.Group>
                    <Form.Label>{fields.wasteTypeId.label} <span className='text-danger'>*</span></Form.Label>
                    <Form.Control
                        as={StyledSmartSelect}
                        isInvalid={!!(errors && errors.wasteTypeId)}
                        value={values.wasteTypeId}
                        placeholder={fields.wasteTypeId.placeholder}
        
                        addText={'Add new waste type'}
                        apiPath={'wasteType'}
                        customParams={{}}
                        fieldNames={{ value: 'wasteTypeId', label: 'wasteTypeName' }}
                        selected={{ wasteTypeId: values.wasteTypeId, wasteTypeName: values.wasteTypeName }}
                        getPopupContainer={(trigger: any) => trigger.parentNode}
        
                        footerRender={(isLoading: boolean, ref: any) => {
                            return <Button
                            variant={'custom-text'}
                            size={'sm'}
                            disabled={isLoading}
                            onClick={(e) => { 
                                e.preventDefault();
                                e.stopPropagation();
        
                                dispatch(modalCreateItemSlice.setShow({ show: true, index: BinWaste.WASTE, id: null, title: 'Waste Type', path: 'wasteType', idField: 'wasteTypeId', nameField: 'wasteTypeName' }));
                            }}
                            ><PlusIcon /> Add new waste type</Button>
                        }}
        
                        hasOptionRender={false}
                        hasFooterRender={true}
                        searchable={true}
                        allowClear={true}
                        selectedIcon={true}
                        disabled={false}
                        virtual={true}
        
                        onChangeValue={async (value: any, option: any, ref: any) => {
                            if(option){
                                await setFieldValue('wasteTypeId', value);
                                await setFieldValue('wasteTypeName', option.wasteTypeName);
                                await setFieldValue('wasteType', option);
                                
                                if(values.binTypeId){
                                    let params = {
                                        wasteTypeId: value,
                                        binTypeId: values.binTypeId,
                                    };
                                    dispatch(slice.callCheckBillingCategoryApi(params, async (state: boolean, data: any) => {
                                        if(state){
                                            let obj = addBillingCategory(data);
                                            if(obj){
                                                await setFieldValue('chargeCategoryId', obj?.chargeCategoryId);
                                                await setFieldValue('chargeCategoryName', obj?.chargeCategoryName);
                                                await setFieldValue('chargeCategory', obj?.chargeCategory);

                                                await setFieldValue('billingType', obj?.billingType);
                                                await setFieldValue('useBinWeightQuantity', obj?.useBinWeightQuantity);
                                                
                                                dispatch(taxRate.setMainTaxRate({ invoiceTaxRate: obj?.invoiceTaxRate, purchaseTaxRate: obj?.purchaseTaxRate }))
                                            }
                                        }
                                    }));
                                }

                            } else {
                                await setFieldValue('wasteTypeId', null);
                                await setFieldValue('wasteTypeName', '');
                                await setFieldValue('wasteType', null);
                                
                                await setFieldValue('billingType', null);
                                await setFieldValue('useBinWeightQuantity', false);
                                await setFieldValue('nonBillableWeight', '');
                                
                                dispatch(taxRate.setMainTaxRate({ invoiceTaxRate: null, purchaseTaxRate: null }))
                            }
                        }}
                    />
                    <Form.Control.Feedback type="invalid">{errors && errors.wasteTypeId as ReactNode}</Form.Control.Feedback>
                </Form.Group>
            </Col>
            <Col xs={12}>
                <Form.Group>
                    <Form.Label>{fields.binTypeId.label}</Form.Label>
                    <Form.Control
                        as={SmartSelect}
                        isInvalid={!!(errors && errors.binTypeId)}
                        value={values.binTypeId}
                        placeholder={fields.binTypeId.placeholder}
        
                        addText={'Add new bin type'}
                        apiPath={'binType'}
                        customParams={{}}
                        fieldNames={{ value: 'binTypeId', label: 'binTypeName' }}
                        selected={{ binTypeId: values.binTypeId, binTypeName: values.binTypeName }}
                        getPopupContainer={(trigger: any) => trigger.parentNode}
        
                        footerRender={(isLoading: boolean, ref: any) => {
                            return <Button
                            variant={'custom-text'}
                            size={'sm'}
                            disabled={isLoading}
                            onClick={(e) => { 
                                e.preventDefault();
                                e.stopPropagation();
                                
                                dispatch(modalCreateItemSlice.setShow({ show: true, index: BinWaste.BIN, id: null, title: 'Bin Type', path: 'binType', idField: 'binTypeId', nameField: 'binTypeName' }));
                            }}
                            ><PlusIcon /> Add new bin type</Button>
                        }}
        
                        hasOptionRender={false}
                        hasFooterRender={true}
                        searchable={true}
                        allowClear={true}
                        selectedIcon={true}
                        disabled={false}
                        virtual={true}
        
                        onChangeValue={async (value: any, option: any, ref: any) => {
                            if(option){
                                await setFieldValue('binTypeId', value);
                                await setFieldValue('binTypeName', option.binTypeName);
                                await setFieldValue('binType', option);
                                
                                if(values.wasteTypeId){
                                    let params = {
                                        wasteTypeId: values.wasteTypeId,
                                        binTypeId: value,
                                    };
                                    dispatch(slice.callCheckBillingCategoryApi(params, async (state: boolean, data: any) => {
                                        if(state){
                                            let obj = addBillingCategory(data);
                                            if(obj){
                                                await setFieldValue('chargeCategoryId', obj?.chargeCategoryId);
                                                await setFieldValue('chargeCategoryName', obj?.chargeCategoryName);
                                                await setFieldValue('chargeCategory', obj?.chargeCategory);

                                                await setFieldValue('billingType', obj?.billingType);
                                                await setFieldValue('useBinWeightQuantity', obj?.useBinWeightQuantity);
                                                
                                                dispatch(taxRate.setMainTaxRate({ invoiceTaxRate: obj?.invoiceTaxRate, purchaseTaxRate: obj?.purchaseTaxRate }))
                                            }
                                        }
                                    }));
                                }

                            } else {
                                await setFieldValue('binTypeId', null);
                                await setFieldValue('binTypeName', '');
                                await setFieldValue('binType', null);
                                
                                await setFieldValue('billingType', null);
                                await setFieldValue('useBinWeightQuantity', false);
                                await setFieldValue('nonBillableWeight', '');
                                
                                dispatch(taxRate.setMainTaxRate({ invoiceTaxRate: null, purchaseTaxRate: null }))
                            }
                        }}
                    />
                    {(values.binType?.isNoninventory) && <div className='gray-800 mt-6'>
                        {fields.binTypeId.info}
                        <StyledInfoIcon />
                    </div>}
                    <Form.Control.Feedback type="invalid">{errors && errors.binTypeId as ReactNode}</Form.Control.Feedback>
                </Form.Group>
            </Col>
        </Row>
    }

    const setMainApplyToSitesElements = () => {
        return <Row>
            <Col xs={12}>
                <Row>
                    <Col xs={12}>
                        <Form.Label>{fields.isSelectAllSites.label}</Form.Label>
                    </Col>
                    <Col xs={12} md={'auto'}>
                        <Radio
                            checked={values.isSelectAllSites == true}
                            onChange={async (e) => {
                                await setFieldValue('isSelectAllSites', true);
                                await setFieldValue('customerSiteId', []);
                                
                                await setFieldValue('autoApplyToNewSites', true);
                            }}
                        >{fields.isSelectAllSites.labelTrue}</Radio>
                    </Col>
                    <Col xs={12} md={true}>
                        <Radio
                            checked={values.isSelectAllSites == false}
                            onChange={async (e) => {
                                await setFieldValue('isSelectAllSites', false);
                            }}
                        >{fields.isSelectAllSites.labelFalse}</Radio>
                    </Col>
                    <Col xs={12} md={'auto'} className='mt-8 mt-md-0'>
                        <Checkbox
                            disabled={values.isSelectAllSites}
                            checked={values.autoApplyToNewSites}
                            onChange={async (e) => {
                                await setFieldValue('autoApplyToNewSites', e.target.checked);
                            }}
                        >{fields.autoApplyToNewSites.label}</Checkbox>
                    </Col>
                </Row>
            </Col>
            {!values.isSelectAllSites && <Col xs={12} className='mt-8'>
                <Form.Group>
                    <Form.Control
                        as={StyledSmartSelect}
                        mode="multiple"
                        maxTagCount={'responsive'}
                        isInvalid={!!(errors && errors.customerSiteId)}
                        value={values.customerSiteId}
                        placeholder={fields.customerSiteId.placeholder}
                        addText={'Add new customer site'}
                        apiPath={'customersite/list'}
                        customParams={{
                            sortColumn: 'siteName',
                            sortDir: 'asc',
                            isIncludeInactive: false,
                            isActive: true,
                            includeServices: false,
                            customerId: customerId,
                        }}
                        fieldNames={{ value: 'customerSiteId', label: 'customSiteName' }}
                        selected={{ customerSiteId: values.customerSiteId, customSiteName: values.customSiteName }}
                        getPopupContainer={(trigger: any) => trigger.parentNode}
                        hasOptionRender={true}
                        hasFooterRender={false}
                        searchable={true}
                        allowClear={true}
                        selectedIcon={false}
                        disabled={false}
                        virtual={true}
                        onChangeValue={async (value: any, option: any, ref: any) => {
                            if(option){
                                await setFieldValue('customerSiteId', option?.map((x: any) => x.customerSiteId));
                                await setFieldValue('customSiteName', option?.map((x: any) => x?.customSiteName));
                            } else {
                                await setFieldValue('customerSiteId', []);
                                await setFieldValue('customSiteName', []);
                            }
                        }}
                        optionRender={(option: any, ref: any) => {
                            return <Row className={'align-items-center gx-2'}>
                                <Col xs={'auto'}>
                                {values.customerSiteId?.includes(option?.value) ? <CheckboxCheckedIcon className='position-relative' style={{ top: '-2' }} /> : <CheckboxUncheckedIcon className='position-relative' style={{ top: '-2' }} />}
                                </Col>
                                <Col xs={'auto'}>{option?.label}</Col>
                            </Row>
                        }}
                        // footerRender={(isLoading: boolean, ref: any) => {
                        //     return <Button
                        //         variant={'custom-text'}
                        //         size={'sm'}
                        //         disabled={isLoading}
                        //         onClick={async (e) => { 
                        //             e.preventDefault();
                        //             e.stopPropagation();

                        //             if(ref){
                        //                 if(ref?.getAllData().every((x: any) => values.customerSiteId?.includes(x.customerSiteId))){
                        //                 await setFieldValue('customerSiteId', []);
                        //                 await setFieldValue('customSiteName', []);
                        //                 } else {
                        //                 await setFieldValue('customerSiteId', ref?.getAllData()?.map((x: any) => x.customerSiteId));
                        //                 await setFieldValue('customSiteName', ref?.getAllData()?.map((x: any) => x.customSiteName));
                        //                 }
                        //             }
                        //         }}
                        //     >
                        //         {isLoading ? <CheckboxUncheckedIcon className='position-relative' style={{ top: '-2' }} /> : ref && ref?.getAllData()?.every((x: any) => values.customerSiteId?.includes(x.customerSiteId)) ? <CheckboxCheckedIcon className='position-relative' style={{ top: '-2' }} /> : <CheckboxUncheckedIcon className='position-relative' style={{ top: '-2' }} />}
                        //         <span className='ps-2'>Select All</span>
                        //     </Button>
                        // }}
                    />
                    <Form.Control.Feedback type="invalid">{errors && errors.customerSiteId as ReactNode}</Form.Control.Feedback>
                </Form.Group>
            </Col>}
        </Row>
    }

    const setMainServiceElements = () => {
        return <>
            <Col xs={12}>
                <Form.Group>
                    <Form.Label>{fields.serviceTag.label} <span className='text-danger'>*</span></Form.Label>
                    <InputGroup>
                        <Form.Control
                            type={'text'}
                            autoComplete='off'
                            tabIndex={1}
                            placeholder={fields.serviceTag.placeholder}
                            maxLength={fields.serviceTag.maxLength}
                            disabled={isLoadingCheckName}
                            value={values.serviceTag}
                            onChange={(e) => {
                                setFieldValue('serviceTag', e.target.value);
                            }}
                            onBlur={(e) => {
                                if(values.serviceTag != ''){
                                    let params = {
                                        serviceItemId: values.serviceItemId,
                                        serviceTag: values.serviceTag,
                                    };
                                    dispatch(slice.callCheckNameApi(params, (state: boolean, data: any) => {}));
                                }
                            }}
                            isInvalid={!!(errors && errors.serviceTag)}
                        />
                        {isLoadingCheckName && <InputGroup.Text className='mt-s2 p-carrency'><Spin spinning size='small' /></InputGroup.Text>}
                    </InputGroup>
                    <Form.Control.Feedback type="invalid">{errors && errors.serviceTag as ReactNode}</Form.Control.Feedback>
                </Form.Group>
            </Col>
            <Col xs={12}>
                <Form.Group>
                    <Form.Label>{fields.description.label}</Form.Label>
                    <Form.Control
                        as="textarea"
                        rows={fields.description.rows}
                        autoComplete='off'
                        placeholder={fields.description.placeholder}
                        disabled={false}
                        value={values.description}
                        onChange={(e) => {
                            limitRows(e.target.value, fields.description.rows, async (value: any) => {
                                await setFieldValue('description', value);
                            });
                        }}
                        isInvalid={!!(errors && errors.description)}
                    />
                    <Form.Control.Feedback type="invalid">{errors && errors.description as ReactNode}</Form.Control.Feedback>
                </Form.Group>
            </Col>

            {(isLocalGlobal === LocalGlobal.LOCAL) && <Col xs={12}>{setMainApplyToSitesElements()}</Col>}
        </>
    }
    const setBundleServiceElements = (item: any, i: number) => {
        return <>
            <Col xs={12}>
                <Form.Group>
                    <Form.Label>{fields.serviceTag.label} <span className='text-danger'>*</span></Form.Label>
                    <Form.Control
                        as={StyledSmartAutocomplete}
                        isInvalid={!!(errors && errors.bundleServices && errors.bundleServices[i] && errors.bundleServices[i].serviceTag)}
                        value={item.serviceTag}
                        placeholder={fields.serviceTag.placeholder}
                        maxLength={fields.serviceTag.maxLength}
        
                        addText={'Add new service'}
                        apiPath={'service-item-template'}
                        customParams={{
                            type: ServiceType.AdditionalService,
                        }}
                        fieldNames={{ value: 'serviceItemTemplateId', label: 'serviceTag' }}
                        selected={{ serviceItemTemplateId: item?.serviceItemTemplateId, serviceTag: item?.serviceTag }}
                        getPopupContainer={(trigger: any) => trigger.parentNode}
        
                        hasOptionRender={false}
                        hasFooterRender={false}
                        searchable={true}
                        allowClear={true}
                        selectedIcon={true}
                        disabled={false}
                        virtual={true}
        
                        onTextChange={async (value: any, ref: any) => {
                            await setFieldValue('bundleServices.' + i + '.serviceTag', value);
                        }}
                        onSelectValue={async (value: any, option: any, ref: any) => {
                            if(option){
                                await setFieldValue('bundleServices.' + i + '.serviceItemTemplateId', value);
                                await setFieldValue('bundleServices.' + i + '.serviceTag', option?.serviceTag);

                                let obj = addBillingCategory(option);
                                if(obj){
                                    await setFieldValue('bundleServices.' + i + '.chargeCategoryId', obj?.chargeCategoryId);
                                    await setFieldValue('bundleServices.' + i + '.chargeCategoryName', obj?.chargeCategoryName);
                                    await setFieldValue('bundleServices.' + i + '.chargeCategory', obj?.chargeCategory);

                                    await setFieldValue('bundleServices.' + i + '.billingType', obj?.billingType);
                                    await setFieldValue('bundleServices.' + i + '.useBinWeightQuantity', obj?.useBinWeightQuantity);
                                    
                                    dispatch(taxRate.setTaxRate({ index: value, invoiceTaxRate: obj?.invoiceTaxRate, purchaseTaxRate: obj?.purchaseTaxRate }))
                                }
                            } else {
                                await setFieldValue('bundleServices.' + i + '.serviceItemTemplateId', null);
                                await setFieldValue('bundleServices.' + i + '.serviceTag', value);

                                await setFieldValue('bundleServices.' + i + '.billingType', null);
                                await setFieldValue('bundleServices.' + i + '.useBinWeightQuantity', false);
                                await setFieldValue('bundleServices.' + i + '.nonBillableWeight', '');
    
                                dispatch(taxRate.setTaxRate({ index: null, invoiceTaxRate: null, purchaseTaxRate: null }))
                            }
                        }}
                    />
                    <Form.Control.Feedback type="invalid">{(errors && errors.bundleServices && errors.bundleServices[i] && errors.bundleServices[i].serviceTag) && errors.bundleServices[i].serviceTag as ReactNode}</Form.Control.Feedback>
                </Form.Group>
            </Col>
            <Col xs={12}>
                <Form.Group>
                    <Form.Label>{fields.description.label}</Form.Label>
                    <Form.Control
                        as="textarea"
                        rows={fields.description.rows}
                        autoComplete='off'
                        placeholder={fields.description.placeholder}
                        disabled={false}
                        value={item.description}
                        onChange={(e) => {
                            limitRows(e.target.value, fields.description.rows, async (value: any) => {
                                await setFieldValue('bundleServices.' + i + '.description', value);
                            });
                        }}
                        isInvalid={!!(errors && errors.bundleServices && errors.bundleServices[i] && errors.bundleServices[i].description)}
                    />
                    <Form.Control.Feedback type="invalid">{(errors && errors.bundleServices && errors.bundleServices[i] && errors.bundleServices[i].description) && errors.bundleServices[i].description as ReactNode}</Form.Control.Feedback>
                </Form.Group>
            </Col>
        </>
    }


    const setMainRateElements = () => {
        let selectedTaxRate = getSelectedTaxRate(values.billingType, taxRateSlice);

        return <>
            <Col xs={12}>
                <Form.Group>
                    <Form.Label>{fields.chargeCategoryId.label} <span className='text-danger'>*</span></Form.Label>
                    <Form.Control
                        as={StyledSmartSelect}
                        isInvalid={!!(errors && errors.chargeCategoryId)}
                        value={values.chargeCategoryId}
                        placeholder={fields.chargeCategoryId.placeholder}
        
                        addText={'Add new category'}
                        apiPath={'chargeCategory'}
                        customParams={{ 
                            includeTaxRate: true 
                        }}
                        fieldNames={{ value: 'chargeCategoryId', label: 'chargeCategoryName' }}
                        selected={{ chargeCategoryId: values.chargeCategoryId, chargeCategoryName: values.chargeCategoryName }}
                        getPopupContainer={(trigger: any) => trigger.parentNode}
        
                        optionRender={(option: any, ref: any) => {
                            return <Row className=''>
                                <Col xs={true}>{option.label}</Col>
                                <Col xs={'auto'}>
                                    {
                                        (option?.data?.useBinWeightQuantity === true)
                                        ?
                                        <Badge bg={'custom-warning'}>By Weight</Badge>
                                        :
                                        <></>
                                    }
                                </Col>
                            </Row>
                        }}
                        footerRender={(isLoading: boolean, ref: any) => {
                            return <Button
                            variant={'custom-text'}
                            size={'sm'}
                            disabled={isLoading}
                            onClick={(e) => { 
                                e.preventDefault();
                                e.stopPropagation();
        
                                dispatch(billingCategorySlice.setShow({ show: true, index: null, id: null }));
                            }}
                            ><PlusIcon /> Add new category</Button>
                        }}
        
                        hasOptionRender={true}
                        hasFooterRender={true}
                        searchable={true}
                        allowClear={true}
                        selectedIcon={false}
                        disabled={false}
                        virtual={true}
        
                        onChangeValue={async (value: any, option: any, ref: any) => {
                            if(option){
                                await setFieldValue('chargeCategoryId', value);
                                await setFieldValue('chargeCategoryName', option.chargeCategoryName);
                                await setFieldValue('chargeCategory', option);
                                                            
                                let billingType = (option) ? option?.billingType : 0;
                                let useBinWeightQuantity = (option) ? option?.useBinWeightQuantity : false;
    
                                await setFieldValue('billingType', billingType);
                                await setFieldValue('useBinWeightQuantity', useBinWeightQuantity);
    
                                let invoiceTaxRate = (option) ? option?.invoiceTaxRate : null;
                                let purchaseTaxRate = (option) ? option?.purchaseTaxRate : null;
                                dispatch(taxRate.setMainTaxRate({ invoiceTaxRate: invoiceTaxRate, purchaseTaxRate: purchaseTaxRate }))
        
                            } else {
                                await setFieldValue('chargeCategoryId', null);
                                await setFieldValue('chargeCategoryName', '');
                                await setFieldValue('chargeCategory', null);
    
                                await setFieldValue('billingType', null);
                                await setFieldValue('useBinWeightQuantity', false);
                                await setFieldValue('nonBillableWeight', '');
    
                                dispatch(taxRate.setMainTaxRate({ invoiceTaxRate: null, purchaseTaxRate: null }))
                            }
                        }}
                    />
                    {(values.useBinWeightQuantity) && <div className='gray-800 mt-6'>
                        {fields.chargeCategoryId.info}
                        <StyledInfoIcon />
                    </div>}
                    <Form.Control.Feedback type="invalid">{errors && errors.chargeCategoryId as ReactNode}</Form.Control.Feedback>
                </Form.Group>
            </Col>
            <Col xs={12}>
                <Form.Group>
                    <Form.Label>{(values.billingType === BillingTypes.Expense) ? fields.price.labelExpense : (values.billingType === BillingTypes.Purchase) ? fields.price.labelPurchase : (values.billingType === BillingTypes.Invoice) ? fields.price.labelInvoice : ''} {fields.price.label}</Form.Label>
                    <InputGroup>
                        <InputGroup.Text className='mt-s1 p-carrency'>{getCurrency()}</InputGroup.Text>
                        <Form.Control
                            as={CurrencyInput}
                            allowDecimals={true}
                            allowNegativeValue={true}
                            disableGroupSeparators={true}
                            // prefix={getCurrency()}
            
                            autoComplete='off'
                            placeholder={fields.price.placeholder}
                            value={values.price}
                            onValueChange={async (value: any) => {
                                await setFieldValue('price', value);
                                                                    
                                if(!isNumberAvoidZero(value)){
                                    await setFieldValue('isTaxInclusive', false);
                                }
                            }}
                            isInvalid={!!(errors && errors.price)}
                        />
                        <InputGroup.Text className='mt-s2'>
                            {(values.useBinWeightQuantity && ((values.bundleServices.length > 0) || values.hasBinWaste)) && <span className='ms-8'>{getBillingPerKgTons()}</span>}
                            {(values.isTaxInclusive && isNumeric(values.price)) && <span className='ms-8 text-success'>({taxRate.getTaxRate(values.isTaxInclusive, values, taxRateSlice)})</span>}
                        </InputGroup.Text>
                    </InputGroup>
                    <Form.Control.Feedback type="invalid">{errors && errors.price as ReactNode}</Form.Control.Feedback>
                </Form.Group>
            </Col>
            <Col xs={12}>
                <Row className='g-8 align-items-center'>
                    <Col xs={'auto'}>
                        <Checkbox
                            disabled={!isNumberAvoidZero(values.price)}
                            checked={values.isTaxInclusive}
                            onChange={async (e: any) => {
                                await setFieldValue('isTaxInclusive', e.target.checked);
                            }}
                        >{fields.isTaxInclusive.label}</Checkbox>
                    </Col>
                    <Col xs={'auto'}>
                        {
                            taxRateSlice.isConnected
                            ?
                            <>
                                <Tooltip title={'Company settings'} className={'dark-tooltip mb-3'}>
                                    <StyledA href={taxRateSlice.accountBillingProfileId ? '/manage/profile/company?id=' + taxRateSlice.accountBillingProfileId + '&selectedTab=1' : '/manage/profiles'}
                                        target={'_blank'}
                                        rel="noopener noreferrer"
                                    >
                                        <SettingsIcon />
                                    </StyledA>
                                </Tooltip>
                            </>
                            :
                            <>
                                <Tooltip title={'Set default tax rate'} className={'dark-tooltip mb-3'}>
                                    <DefaultTaxRatePopup />
                                </Tooltip>
                            </>
                        }
                    </Col>
                    {(values.isTaxInclusive && isNumeric(values.price) && isNumeric(selectedTaxRate) && (!taxRateSlice.isLoading)) && <Col xs={'auto'}>
                        <div className='mt-s2'>Tax rate is {selectedTaxRate}%</div>
                    </Col>}
                </Row>
            </Col>

            {(values.useBinWeightQuantity && isNumeric(values.binTypeId)) && <Col xs={12}>
                <Form.Group>
                    <Form.Label>{fields.nonBillableWeight.label}</Form.Label>
                    <InputGroup>
                        <Form.Control
                            as={CurrencyInput}
                            allowDecimals={true}
                            decimalsLimit={getMaxLength(values.uom)}
                            allowNegativeValue={false}
                            disableGroupSeparators={true}
                            // prefix={getCurrency()}
            
                            autoComplete='off'
                            placeholder={fields.nonBillableWeight.placeholder}
                            value={values.nonBillableWeight}
                            onValueChange={async (value: any) => {
                                await setFieldValue('nonBillableWeight', value);
                            }}
                            isInvalid={!!(errors && errors.nonBillableWeight)}
                        />
                        <InputGroup.Text className='mt-s2'>
                            <span className='ms-8 text-success'>{getBillingKgTons()}</span>
                        </InputGroup.Text>
                    </InputGroup>
                    <Form.Control.Feedback type="invalid">{errors && errors.nonBillableWeight as ReactNode}</Form.Control.Feedback>
                </Form.Group>
            </Col>}
        </>
    }
    const setBundleRateElements = (item: any, i: number) => {
        let selectedTaxRate = getSelectedTaxRate(item?.billingType, taxRateSlice);

        return <>
            <Col xs={12}>
                <Form.Group>
                    <Form.Label>{fields.chargeCategoryId.label} <span className='text-danger'>*</span></Form.Label>
                    <Form.Control
                        as={StyledSmartSelect}
                        isInvalid={!!(errors && errors.bundleServices && errors.bundleServices[i] && errors.bundleServices[i].chargeCategoryId)}
                        value={item?.chargeCategoryId}
                        placeholder={fields.chargeCategoryId.placeholder}
        
                        addText={'Add new category'}
                        apiPath={'chargeCategory'}
                        customParams={{ 
                            includeTaxRate: true 
                        }}
                        fieldNames={{ value: 'chargeCategoryId', label: 'chargeCategoryName' }}
                        selected={{ chargeCategoryId: item?.chargeCategoryId, chargeCategoryName: item?.chargeCategoryName }}
                        getPopupContainer={(trigger: any) => trigger.parentNode}
        
                        optionRender={(option: any, ref: any) => {
                            return <Row className=''>
                                <Col xs={true}>{option.label}</Col>
                                <Col xs={'auto'}>
                                    {
                                        (option?.data?.useBinWeightQuantity === true)
                                        ?
                                        <Badge bg={'custom-warning'}>By Weight</Badge>
                                        :
                                        <></>
                                    }
                                </Col>
                            </Row>
                        }}
                        footerRender={(isLoading: boolean, ref: any) => {
                            return <Button
                            variant={'custom-text'}
                            size={'sm'}
                            disabled={isLoading}
                            onClick={(e) => { 
                                e.preventDefault();
                                e.stopPropagation();
        
                                dispatch(billingCategorySlice.setShow({ show: true, index: i, id: null }));
                            }}
                            ><PlusIcon /> Add new category</Button>
                        }}
        
                        hasOptionRender={true}
                        hasFooterRender={true}
                        searchable={true}
                        allowClear={true}
                        selectedIcon={false}
                        disabled={false}
                        virtual={true}
        
                        onChangeValue={async (value: any, option: any, ref: any) => {
                            if(option){
                                await setFieldValue('bundleServices.' + i + '.chargeCategoryId', value);
                                await setFieldValue('bundleServices.' + i + '.chargeCategoryName', option.chargeCategoryName);
                                await setFieldValue('bundleServices.' + i + '.chargeCategory', option);
                                                            
                                let billingType = (option) ? option?.billingType : 0;
                                let useBinWeightQuantity = (option) ? option?.useBinWeightQuantity : false;
    
                                await setFieldValue('bundleServices.' + i + '.billingType', billingType);
                                await setFieldValue('bundleServices.' + i + '.useBinWeightQuantity', useBinWeightQuantity);
    
                                let invoiceTaxRate = (option) ? option?.invoiceTaxRate : null;
                                let purchaseTaxRate = (option) ? option?.purchaseTaxRate : null;
                                dispatch(taxRate.setTaxRate({ index: value, invoiceTaxRate: invoiceTaxRate, purchaseTaxRate: purchaseTaxRate }))
        
                            } else {
                                await setFieldValue('bundleServices.' + i + '.chargeCategoryId', null);
                                await setFieldValue('bundleServices.' + i + '.chargeCategoryName', '');
                                await setFieldValue('bundleServices.' + i + '.chargeCategory', null);
    
                                await setFieldValue('bundleServices.' + i + '.billingType', null);
                                await setFieldValue('bundleServices.' + i + '.useBinWeightQuantity', false);
                                await setFieldValue('bundleServices.' + i + '.nonBillableWeight', '');
    
                                dispatch(taxRate.setTaxRate({ index: null, invoiceTaxRate: null, purchaseTaxRate: null }))
                            }
                        }}
                    />
                    {(item?.useBinWeightQuantity) && <div className='gray-800 mt-6'>
                        {fields.chargeCategoryId.info}
                        <StyledInfoIcon />
                    </div>}
                    <Form.Control.Feedback type="invalid">{(errors && errors.bundleServices && errors.bundleServices[i] && errors.bundleServices[i].chargeCategoryId) && errors.bundleServices[i].chargeCategoryId as ReactNode}</Form.Control.Feedback>
                </Form.Group>
            </Col>
            <Col xs={12}>
                <Form.Group>
                    <Form.Label>{(item?.billingType === BillingTypes.Expense) ? fields.price.labelExpense : (item?.billingType === BillingTypes.Purchase) ? fields.price.labelPurchase : (item?.billingType === BillingTypes.Invoice) ? fields.price.labelInvoice : ''} {fields.price.label}</Form.Label>
                    <InputGroup>
                        <InputGroup.Text className='mt-s2 p-carrency'>{getCurrency()}</InputGroup.Text>
                        <Form.Control
                            as={CurrencyInput}
                            allowDecimals={true}
                            allowNegativeValue={true}
                            disableGroupSeparators={true}
                            // prefix={getCurrency()}
            
                            autoComplete='off'
                            placeholder={fields.price.placeholder}
                            value={item?.price}
                            onValueChange={async (value: any) => {
                                await setFieldValue('bundleServices.' + i + '.price', value);
                                                                    
                                if(!isNumberAvoidZero(value)){
                                    await setFieldValue('bundleServices.' + i + '.isTaxInclusive', false);
                                }
                            }}
                            isInvalid={!!(errors && errors.bundleServices && errors.bundleServices[i] && errors.bundleServices[i].price)}
                        />
                        <InputGroup.Text className='mt-s2'>
                            {(item?.useBinWeightQuantity) && <span className='ms-8'>{getBillingPerKgTons()}</span>}
                            {(item?.isTaxInclusive && isNumeric(item?.price)) && <span className='ms-8 text-success'>({taxRate.getTaxRate(item?.isTaxInclusive, item, taxRateSlice)})</span>}
                        </InputGroup.Text>
                    </InputGroup>
                    <Form.Control.Feedback type="invalid">{(errors && errors.bundleServices && errors.bundleServices[i] && errors.bundleServices[i].price) && errors.bundleServices[i].price as ReactNode}</Form.Control.Feedback>
                </Form.Group>
            </Col>
            <Col xs={12}>
                <Row className='g-8 align-items-center'>
                    <Col xs={'auto'}>
                        <Checkbox
                            disabled={!isNumberAvoidZero(item?.price)}
                            checked={item?.isTaxInclusive}
                            onChange={async (e: any) => {
                                await setFieldValue('bundleServices.' + i + '.isTaxInclusive', e.target.checked);
                            }}
                        >{fields.isTaxInclusive.label}</Checkbox>
                    </Col>
                    <Col xs={'auto'}>
                        {
                            taxRateSlice.isConnected
                            ?
                            <>
                                <Tooltip title={'Company settings'} className={'dark-tooltip mb-3'}>
                                    <StyledA href={taxRateSlice.accountBillingProfileId ? '/manage/profile/company?id=' + taxRateSlice.accountBillingProfileId + '&selectedTab=1' : '/manage/profiles'}
                                        target={'_blank'}
                                        rel="noopener noreferrer"
                                    >
                                        <SettingsIcon />
                                    </StyledA>
                                </Tooltip>
                            </>
                            :
                            <>
                                <DefaultTaxRatePopup />
                            </>
                        }
                    </Col>
                    {(item?.isTaxInclusive && isNumeric(item?.price) && isNumeric(selectedTaxRate) && (!taxRateSlice.isLoading)) && <Col xs={'auto'}>
                        <div className='mt-s2'>Tax rate is {selectedTaxRate}%</div>
                    </Col>}
                </Row>
            </Col>

            {(item?.useBinWeightQuantity && isNumeric(values.binTypeId)) && <Col xs={12}>
                <Form.Group>
                    <Form.Label>{fields.nonBillableWeight.label}</Form.Label>
                    <InputGroup>
                        <Form.Control
                            as={CurrencyInput}
                            allowDecimals={true}
                            decimalsLimit={getMaxLength(values.uom)}
                            allowNegativeValue={false}
                            disableGroupSeparators={true}
                            // prefix={getCurrency()}
            
                            autoComplete='off'
                            placeholder={fields.nonBillableWeight.placeholder}
                            value={item?.nonBillableWeight}
                            onValueChange={async (value: any) => {
                                await setFieldValue('bundleServices.' + i + '.nonBillableWeight', value);
                            }}
                            isInvalid={!!(errors && errors.bundleServices && errors.bundleServices[i] && errors.bundleServices[i].nonBillableWeight)}
                        />
                        <InputGroup.Text className='mt-s2'>
                            <span className='ms-8 text-success'>{getBillingKgTons()}</span>
                        </InputGroup.Text>
                    </InputGroup>
                    <Form.Control.Feedback type="invalid">{(errors && errors.bundleServices && errors.bundleServices[i] && errors.bundleServices[i].nonBillableWeight) && errors.bundleServices[i].nonBillableWeight as ReactNode}</Form.Control.Feedback>
                </Form.Group>
            </Col>}
        </>
    }


    return <Offcanvas
        className={'wp-v5'}
        backdrop={'static'}
        backdropClassName={props?.backdropClassName || ''}
        enforceFocus={false}
        scroll={false}
        placement={'end'}
        show={show}
        onHide={() => {
            onCancel();
        }}
        style={{ width: '600px' }}
    >
        <FormikContext.Provider value={formik}>
            <Offcanvas.Header closeButton>
                <Offcanvas.Title>{(id && id > 0) ? 'Edit' : 'Create'} {(isLocalGlobal === LocalGlobal.LOCAL) ? 'Local' : 'Global'} Service</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
                <Spin spinning={isLoading}>
                    <Row className={'g-2'}>
                        <Col xs={12}>{setForm()}</Col>
                    </Row>
                </Spin>
            </Offcanvas.Body>
            <Modal.Footer className='border-top'>{setFooter()}</Modal.Footer>
        </FormikContext.Provider>

        <BillingCategoryForm
            onCreate={async (index: any, data: any) => {
                if(isNumeric(index)){
                    await setFieldValue('bundleServices.' + index + '.chargeCategoryId', data?.chargeCategoryId);
                    await setFieldValue('bundleServices.' + index + '.chargeCategoryName', data?.chargeCategoryName);
                    await setFieldValue('bundleServices.' + index + '.chargeCategory', data);

                    let billingType = (data) ? data?.billingType : 0;
                    let useBinWeightQuantity = (data) ? data?.useBinWeightQuantity : false;

                    await setFieldValue('bundleServices.' + index + '.billingType', billingType);
                    await setFieldValue('bundleServices.' + index + '.useBinWeightQuantity', useBinWeightQuantity);

                    let invoiceTaxRate = (data) ? data?.invoiceTaxRate : null;
                    let purchaseTaxRate = (data) ? data?.purchaseTaxRate : null;
                    dispatch(taxRate.setTaxRate({ index: data?.chargeCategoryId, invoiceTaxRate: invoiceTaxRate, purchaseTaxRate: purchaseTaxRate }))

                } else {
                    await setFieldValue('chargeCategoryId', data?.chargeCategoryId);
                    await setFieldValue('chargeCategoryName', data?.chargeCategoryName);
                    await setFieldValue('chargeCategory', data);
                    
                    let billingType = (data) ? data?.billingType : 0;
                    let useBinWeightQuantity = (data) ? data?.useBinWeightQuantity : false;

                    await setFieldValue('billingType', billingType);
                    await setFieldValue('useBinWeightQuantity', useBinWeightQuantity);

                    let invoiceTaxRate = (data) ? data?.invoiceTaxRate : null;
                    let purchaseTaxRate = (data) ? data?.purchaseTaxRate : null;
                    dispatch(taxRate.setMainTaxRate({ invoiceTaxRate: invoiceTaxRate, purchaseTaxRate: purchaseTaxRate }))
                }
            }}
            onUpdate={(index: any, data: any) => {}}
            onDelete={(index: any, data: any) => {}}
        />

        <ModalCreateItemForm
            onCreate={async (index: any, option: any) => {
                if(index === BinWaste.WASTE){
                    if(option){
                        await setFieldValue('wasteTypeId', option?.wasteTypeId);
                        await setFieldValue('wasteTypeName', option?.wasteTypeName);
                        await setFieldValue('wasteType', option);
                        
                        if(values.binTypeId){
                            let params = {
                                wasteTypeId: option?.wasteTypeId,
                                binTypeId: values.binTypeId,
                            };
                            dispatch(slice.callCheckBillingCategoryApi(params, async (state: boolean, data: any) => {
                                if(state){
                                    let obj = addBillingCategory(data);
                                    if(obj){
                                        await setFieldValue('chargeCategoryId', obj?.chargeCategoryId);
                                        await setFieldValue('chargeCategoryName', obj?.chargeCategoryName);
                                        await setFieldValue('chargeCategory', obj?.chargeCategory);

                                        await setFieldValue('billingType', obj?.billingType);
                                        await setFieldValue('useBinWeightQuantity', obj?.useBinWeightQuantity);
                                        
                                        dispatch(taxRate.setMainTaxRate({ invoiceTaxRate: obj?.invoiceTaxRate, purchaseTaxRate: obj?.purchaseTaxRate }))
                                    }
                                }
                            }));
                        }
                    }

                } else if(index === BinWaste.BIN){
                    if(option){
                        await setFieldValue('binTypeId', option?.binTypeId);
                        await setFieldValue('binTypeName', option?.binTypeName);
                        await setFieldValue('binType', option);
                        
                        if(values.wasteTypeId){
                            let params = {
                                wasteTypeId: values.wasteTypeId,
                                binTypeId: option?.binTypeId,
                            };
                            dispatch(slice.callCheckBillingCategoryApi(params, async (state: boolean, data: any) => {
                                if(state){
                                    let obj = addBillingCategory(data);
                                    if(obj){
                                        await setFieldValue('chargeCategoryId', obj?.chargeCategoryId);
                                        await setFieldValue('chargeCategoryName', obj?.chargeCategoryName);
                                        await setFieldValue('chargeCategory', obj?.chargeCategory);

                                        await setFieldValue('billingType', obj?.billingType);
                                        await setFieldValue('useBinWeightQuantity', obj?.useBinWeightQuantity);
                                        
                                        dispatch(taxRate.setMainTaxRate({ invoiceTaxRate: obj?.invoiceTaxRate, purchaseTaxRate: obj?.purchaseTaxRate }))
                                    }
                                }
                            }));
                        }
                    }
                }
            }}
            onUpdate={async (index: any, option: any) => {}}
            onDelete={async (index: any, id: any) => {}}
        />
    </Offcanvas>
}

export default FormComponent;
